var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDineIn(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7435 3.56738H9.25911V9.01009H7.77474V3.89827C7.03564 4.32503 6.53776 5.12598 6.53776 6.04134V9.01009H5.05339V6.04134C5.05339 3.85498 6.82536 2.08301 9.01172 2.08301H10.9909C13.1772 2.08301 14.9492 3.85498 14.9492 6.04134V9.01009H13.4648V6.04134C13.4648 5.12598 12.967 4.32503 12.2279 3.89827V9.01009H10.7435V3.56738ZM5.14925 11.484L4.59261 12.9684H15.41L14.8534 11.484H5.14925ZM3.75765 10.9614C3.97412 10.3831 4.52767 9.99967 5.14616 9.99967H14.8534C15.4718 9.99967 16.0254 10.3831 16.2419 10.9614L16.8356 12.5479C16.8944 12.7056 16.9253 12.8726 16.9253 13.0426C16.9253 13.6735 16.5078 14.2085 15.9357 14.3879V17.1711C15.9357 17.5824 15.6048 17.9132 15.1935 17.9132C14.7822 17.9132 14.4513 17.5824 14.4513 17.1711V14.4528H5.54818V17.1742C5.54818 17.5854 5.21729 17.9163 4.80599 17.9163C4.39469 17.9163 4.0638 17.5854 4.0638 17.1742V14.391C3.4917 14.2116 3.07422 13.6766 3.07422 13.0457C3.07422 12.8757 3.10514 12.7087 3.1639 12.5509L3.75765 10.9645V10.9614Z",
    fill: "#334155"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDineIn);
export default __webpack_public_path__ + "static/media/dine-in.7bafafe9424dc2ab9b2ebde00d50aaa7.svg";
export { ForwardRef as ReactComponent };